import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1ProjectPlanAuditIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class ProjectPlanAuditLogEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlan-003";

        let qbe = btoa(JSON.stringify({
            "PlatformMessage": {
                "-idoc": "v1.ProjectPlan-003",
                "-id": uuidv4(),
                "ProjectPlan": {
                    "_attributes": {
                        "limit": 1,
                        "sort": null,
                        "offset": 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": foreignKey,
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    "ProjectPlanAuditHistory": {
                        "_attributes": {
                            "limit": pageSize,
                            "sort": this.getFormattedSortSpecification(),
                            "offset": (page - 1) * pageSize
                        }
                    }
                }
            }
        }))

        AxiosFoundationAPI({
            method: "GET",
            url: "t1/v1/project_plans",
            json: true,
            params: {
                "QBE": qbe
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanAuditIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default ProjectPlanAuditLogEnterpriseComponent;